import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ParentPaper } from '../../atoms/parent-paper';
import { Group } from '../../organisms/group';
import { SpotPricePeriodSelect } from '../../organisms/spot/spot-price-period-select';
import { SpotRegionSelect } from '../../organisms/spot/spot-region-select';
import { SettingsSpotDistributionPrices } from './boxes/settings-spot-distribution-prices';
import { SettingsSpotOverflowPrice } from './boxes/settings-spot-overflow-price';

export const SettingsSpot = () => {
  return (
    <Group
      title={<FormattedMessage id="settings.spot" defaultMessage="Spot" />}
      layout="list"
      visibility={{ variableId: 'SP_INSTALL' }}
    >
      <ParentPaper>
        <SpotRegionSelect />
        <SpotPricePeriodSelect />

        <SettingsSpotOverflowPrice />
        <SettingsSpotDistributionPrices />
      </ParentPaper>
    </Group>
  );
};
